// extracted by mini-css-extract-plugin
export var errorIcon = "_kb-1";
export var nameLogo = "_kb-0";